
import { mapState, mapMutations } from "vuex";
import { Partners } from "@/graphql/partners";

export default {
  nuxtI18n: {
    paths: {
      "en-ca": "/partners",
      "fr-ca": "/partenaires",
    },
  },
  async asyncData({ app, i18n }) {
    const client = app.apolloProvider.defaultClient;
    const locale = i18n.locale.slice(0, 3) + i18n.locale.slice(3).toUpperCase();
    const partnersResponse = await client.query({
      query: Partners,
      variables: { locale: locale },
    });
    const partenaire = partnersResponse.data.partenaire.data.attributes;
    return { partenaire };
  },
  data() {
    return {
      partenaire: {},
      show: false,
      anchorSelected: "",
    };
  },
  head() {
    return {
      title: this.partenaire.SEO.MetaTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.partenaire.SEO.MetaDescription,
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.partenaire.SEO.MetaDescription,
        },
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    setTimeout(() => this.setPageAnimation("animBanner"), 500);
  },
  computed: {
    ...mapState(["pageScroll"]),
  },
  methods: {
    ...mapMutations({
      setPageAnimation: "SET_PAGE_ANIMATION",
    }),
  },
  watch: {
    pageScroll: function () {
      //Ajouter - le height du Header fix apres le bottom
      let haveShow = false;
      if (
        this.$refs.animated?.getBoundingClientRect().bottom -
          window.innerHeight +
          100 <=
        0
      ) {
        this.show = true;
        haveShow = true;
      }
    },
  },
};
